import axios from '@/service/apiProvider.service'

/**
 * State.
 */
export const state: any = {
  accounts: [],
  permissions: [],
  views: [],
}

/**
 * Getters.
 */
export const getters: any = {
  all (state: any): any {
    return state
  },

  accounts (state: any): any {
    return state.accounts
  },

  permissions (state: any): any {
    return state.permissions
  },

  views (state: any): any {
    return state.views
  }
}

/**
 * Mutations.
 */
export const mutations: any = {
  SET_ACC (state: any, payload: any): void {
    state.accounts = payload
  },

  SET_PER (state: any, payload: any): void {
    state.permissions = payload
  },

  SET_VIE (state: any, payload: any): void {
    state.views = payload
  }
}

/**
 * Actions.
 */
export const actions: any = {
  /**
   * Pull Users Accounts.
   * 
   * @return {Promise}
   */
  async callAcc ({ commit }: any) {
    let status: boolean = false

    try {
      const { data }: any = await axios('/user')
      commit('SET_ACC', data)
      status = true
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  },

  /**
   * Pull Permissions.
   * 
   * @return {Promise}
   */
  async callPer ({ commit }: any) {
    let status: boolean = false

    try {
      const { data }: any = await axios('/permission')
      commit('SET_PER', data)
      status = true
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  },

  /**
   * Pull Permissions.
   * 
   * @return {Promise}
   */
  async callVie ({ commit }: any) {
    let status: boolean = false

    try {
      const { data }: any = await axios('/view')
      commit('SET_VIE', data)
      status = true
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  },

  /**
   * @param {Object} obj
   * @return {Promise}
   */
  async allFetch ({ dispatch }: any, h: any) {
    let status: any = false
    
    try {
      const { data }: any = await axios[h.method.toLocaleLowerCase()](h.path, h.body)
      status = data.status
      if (status) dispatch(h.dispatch)
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  }
}